import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BaseURL } from "../../../../Files/BaseURL";
import AlertContext from "../../../../Context/Alert/AlertContext";
import { formatDateForInput } from "../../../../Files/UseFunction";
import ThemeContext from "../../../../Context/theme/ThemeContext";
import { FaSearch } from "react-icons/fa";

const ActiveAdd = () => {
  const navigate = useNavigate();
  const { theme } = useContext(ThemeContext);
  const { showAlert } = useContext(AlertContext);

  const [Products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalProducts, setTotalProducts] = useState(0);

  const fetchAdds = async (page = currentPage) => {
    try {
      setLoading(true);
      const authToken = localStorage.getItem("p@token");
      const response = await axios.get(
        `${BaseURL}/api/product/activeProducts?page=${page}&limit=${itemsPerPage}${
          searchTerm ? `&search=${searchTerm}` : ""
        }`,
        {
          headers: {
            "auth-token": authToken,
          },
        }
      );

      if (response.data.success) {
        setProducts(response.data.products);
        setTotalPages(response.data.pagination.totalPages);
        setTotalProducts(response.data.pagination.totalProducts);
      } else {
        showAlert(
          response.data.message || "Error fetching active products",
          "danger"
        );
      }
    } catch (error) {
      showAlert("Error fetching active products", "danger");
    } finally {
      setLoading(false);
    }
  };

  // Fetch products when component mounts or search term changes
  useEffect(() => {
    setCurrentPage(1); // Reset to first page when filters change
    fetchAdds(1);
  }, [searchTerm, itemsPerPage]);

  // Fetch products when page changes
  useEffect(() => {
    fetchAdds(currentPage);
  }, [currentPage]);

  // Update search input
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const archiveProduct = async (productId) => {
    try {
      const authToken = localStorage.getItem("p@token");
      await axios.put(
        `${BaseURL}/api/product/archive/${productId}`,
        {},
        {
          headers: {
            "auth-token": authToken,
          },
        }
      );
      showAlert("Product moved to archive", "success");
      fetchAdds(currentPage); // Refresh the current page
    } catch (error) {
      showAlert("Error moving product to archive", "danger");
    }
  };

  return (
    <div>
      <div className="flex flex-col gap-4 lg:flex-row justify-between font-pop lg:items-center">
        <div className="flex gap-2 md:gap-6 items-center">
          <h3
            className={`text-gray-400 text-sm md:text-lg font-medium ${
              theme === "dark" && "text-white"
            }`}
          >
            Total {totalProducts}
          </h3>
          {/* Add search input */}
          <div className="flex gap-3 items-center bg-gray-300 rounded-full py-2 px-4">
            <FaSearch className="text-gray-400 text-lg md:text-2xl" />
            <input
              type="text"
              value={searchTerm}
              onChange={handleSearch}
              placeholder="Search..."
              className="bg-transparent text-sm md:text-lg border-none outline-none focus:outline-none focus:border-none active:outline-none"
            />
          </div>
        </div>
        <div
          className="bg-primarygreen text-center w-fit border-2 border-primarygreen rounded-full font-pop text-white py-2 px-5 cursor-pointer"
          onClick={() => {
            navigate("/user-dashboard/adds/createadd");
          }}
        >
          Create Ad
        </div>
      </div>

      {loading ? (
        <div className="flex items-center justify-center py-10">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primarygreen"></div>
        </div>
      ) : (
        <>
          <div className="bg-transparent overflow-x-scroll font-pop w-full my-2 md:my-2">
            <table className="overflow-x-scroll border-spacing-y-4 border-separate w-full">
              <thead>
                <tr>
                  <th
                    scope="col"
                    className={`px-2 md:px-6 py-1 md:py-3 text-left w-[30%] font-medium text-gray-500 u}percase
                                ${theme == "dark" && " text-white"} `}
                  >
                    Title
                  </th>
                  <th
                    scope="col"
                    className={`px-2 md:px-6 py-1 md:py-3 text-left font-medium text-gray-500 uppercase
                                 ${theme == "dark" && " text-white"} `}
                  >
                    Category
                  </th>
                  <th
                    scope="col"
                    className={`px-2 md:px-6 py-1 md:py-3 text-left font-medium text-gray-500 uppercase
                               ${theme == "dark" && "b text-white"} `}
                  >
                    Price
                  </th>
                  <th
                    scope="col"
                    className={`px-2 md:px-6 py-1 md:py-3 text-left font-medium text-gray-500 uppercase
                               ${theme == "dark" && " text-white"} `}
                  >
                    Published
                  </th>
                  <th
                    scope="col"
                    className={`px-2 md:px-6 py-1 md:py-3 text-left font-medium text-gray-500 uppercase ${
                      theme == "dark" && " text-white"
                    } `}
                  >
                    Boosted
                  </th>
                  <th
                    scope="col"
                    className={`px-2 md:px-6 py-1 md:py-3 text-left font-medium text-gray-500 uppercase
                                ${theme == "dark" && "b text-white"} `}
                  ></th>
                </tr>
              </thead>
              <tbody>
                {Products?.map((item, index) => (
                  <tr
                    onClick={() => {
                      navigate(`/user-dashboard/adds/addOverview/${item._id}`);
                    }}
                    key={index}
                  >
                    <td
                      className={`px-2 md:px-6 rounded-l-2xl  my-3 text-base md:text-lg font-semibold py-3 text-left w-max min-w-[30%]
                                     ${
                                       theme === "dark"
                                         ? "bg-black text-white"
                                         : "bg-white"
                                     } `}
                    >
                      <h2 className="w-max">{item?.Title}</h2>
                    </td>
                    <td
                      className={`px-2 md:px-6  my-3 py-1 md:py-3 font-normal text-left *: ${
                        theme === "dark" ? "bg-black text-white" : "bg-white"
                      }  `}
                    >
                      <h2 className="w-max">{item?.Category?.name}</h2>
                    </td>
                    <td
                      className={`px-2 md:px-6  my-3 py-1 md:py-3 text-left font-semibold 
                                     ${
                                       theme === "dark"
                                         ? "bg-black text-white"
                                         : "bg-white"
                                     } `}
                    >
                      <h2 className="w-max">${item?.Price}</h2>
                    </td>
                    <td
                      className={`px-2 md:px-6 text-lightGrey  my-3 py-1 md:py-3 text-left 
                                     ${
                                       theme === "dark"
                                         ? "bg-black text-white"
                                         : "bg-white"
                                     } `}
                    >
                      <h2 className="w-max">{formatDateForInput(item.date)}</h2>
                    </td>
                    <td
                      className={`px-2 md:px-6  my-3 py-1 md:py-3 font-normal text-left *: ${
                        theme === "dark" ? "bg-black text-white" : "bg-white"
                      }  `}
                    >
                      <h2
                        className={`w-max ${
                          item?.hasActiveAd ? "text-green-600" : "text-red-600"
                        }`}
                      >
                        {item?.hasActiveAd ? "YES" : "NO"}
                      </h2>
                    </td>
                    <td
                      className={`px-2 md:px-6 rounded-r-2xl w-fit my-3 py-1 md:py-3 text-left 
                                     ${
                                       theme === "dark"
                                         ? "bg-black text-white"
                                         : "bg-white"
                                     } `}
                    >
                      <div className="flex gap-2">
                        {!item?.hasActiveAd && (
                          <button
                            onClick={() =>
                              navigate(
                                `/user-dashboard/adds/addOverview/${item._id}`
                              )
                            }
                            className={`m-1 w-max bg-green-500 hover:bg-transparent hover:bg-white-500 font-normal  py-1 px-4 border border-black-500 hover:border-green-500 rounded-full text-white ${
                              theme === "dark"
                                ? "hover:text-white"
                                : "hover:text-black"
                            } `}
                          >
                            Boost
                          </button>
                        )}
                        <button
                          onClick={() => archiveProduct(item._id)}
                          className="m-1 w-max bg-transparent hover:bg-green-500 text-black-700 font-normal hover:text-white py-1 px-4 border border-black-500 hover:border-transparent rounded-full "
                        >
                          Move to Archive
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {Products?.length > 0 && (
            <div className="flex items-center justify-between border-t border-gray-200 px-4 py-3 sm:px-6 mt-4 rounded-lg">
              <div className="flex flex-1 justify-between sm:hidden">
                {/* Mobile view */}
                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  disabled={currentPage === 1}
                  className={`relative inline-flex items-center px-4 py-2 text-sm font-semibold ${
                    currentPage === 1
                      ? "bg-gray-100 text-gray-400"
                      : "bg-white text-gray-700 hover:bg-gray-50"
                  } ring-1 ring-inset ring-gray-300 rounded-md`}
                >
                  Previous
                </button>
                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  disabled={currentPage === totalPages}
                  className={`relative ml-3 inline-flex items-center px-4 py-2 text-sm font-semibold ${
                    currentPage === totalPages
                      ? "bg-gray-100 text-gray-400"
                      : "bg-white text-gray-700 hover:bg-gray-50"
                  } ring-1 ring-inset ring-gray-300 rounded-md`}
                >
                  Next
                </button>
              </div>

              {/* Desktop view */}
              <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
                {/* Left side - Items per page */}
                <div>
                  <div className="flex items-center gap-4 font-bold font-pop text-xs">
                    <select
                      value={itemsPerPage}
                      onChange={(e) => setItemsPerPage(Number(e.target.value))}
                      className="block w-20 rounded-md border-0 py-1.5 pl-3 pr-8 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-primarygreen sm:text-sm sm:leading-6"
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>
                    <p className="text-sm text-gray-700">items per page</p>
                  </div>
                </div>

                {/* Center - Items count */}
                <div className="font-pop text-xs font-bold">
                  <p className="text-sm text-gray-700">
                    {`${(currentPage - 1) * itemsPerPage + 1}-${Math.min(
                      currentPage * itemsPerPage,
                      totalProducts
                    )} of ${totalProducts} items`}
                  </p>
                </div>

                {/* Right side - Navigation and pages */}
                <div className="flex items-center gap-4 font-bold font-pop text-xs">
                  <div className="flex items-center gap-2">
                    <p className="text-sm text-gray-700">Page</p>
                    <p className="text-sm font-bold text-gray-900">
                      {currentPage}
                    </p>
                    <p className="text-sm text-gray-700">of</p>
                    <p className="text-sm font-bold text-gray-900">
                      {totalPages}
                    </p>
                    <p className="text-sm text-gray-700">pages</p>
                  </div>
                  <nav
                    className="isolate inline-flex -space-x-px rounded-md shadow-sm"
                    aria-label="Pagination"
                  >
                    <button
                      onClick={() =>
                        setCurrentPage((prev) => Math.max(prev - 1, 1))
                      }
                      disabled={currentPage === 1}
                      className={`relative inline-flex items-center rounded-l-md px-2 py-2 ${
                        currentPage === 1
                          ? "bg-gray-100 text-gray-400"
                          : "bg-white text-gray-500 hover:bg-gray-50"
                      } ring-1 ring-inset ring-gray-300 focus:z-20 focus:outline-offset-0`}
                    >
                      <span className="sr-only">Previous</span>
                      <svg
                        className="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fillRule="evenodd"
                          d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </button>

                    <button
                      onClick={() =>
                        setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                      }
                      disabled={currentPage === totalPages}
                      className={`relative inline-flex items-center rounded-r-md px-2 py-2 ${
                        currentPage === totalPages
                          ? "bg-gray-100 text-gray-400"
                          : "bg-white text-gray-500 hover:bg-gray-50"
                      } ring-1 ring-inset ring-gray-300 focus:z-20 focus:outline-offset-0`}
                    >
                      <span className="sr-only">Next</span>
                      <svg
                        className="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fillRule="evenodd"
                          d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </button>
                  </nav>

                  {/* Pages display */}
                </div>
              </div>
            </div>
          )}

          {/* Show no data message */}
          {Products.length === 0 && (
            <div className="text-center py-4 font-pop text-lg font-medium">
              No Active Ad's found
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ActiveAdd;
